import { useAdminConfig } from '../../../hooks/useAdminConfig'

export default function Ajustes() {
  const { config, loading, updateConfig } = useAdminConfig()

  return (
    <div>
      <h1 className="text-3xl font-bold text-gradient mb-8">Ajustes del Sistema</h1>
      <p className="text-gray-300 mb-8">Aquí podrás configurar los ajustes generales del sitio web.</p>

      <div className="space-y-6 max-w-md">
        <div className="mb-6 p-4 bg-primary/10 border border-primary/30 rounded-lg text-sm text-primary">
          <b>Nota:</b> Estas opciones solo afectan la visibilidad de las secciones <b>Blog</b> y <b>Equipo</b> en el menú público del sitio web. En el panel de administración siempre estarán disponibles para gestión interna.
        </div>
        <div className="flex items-center justify-between">
          <span className="font-medium text-white">Mostrar sección Blog en el menú</span>
          <input
            type="checkbox"
            checked={!!config.showBlog}
            disabled={loading}
            onChange={e => {
              updateConfig({ showBlog: e.target.checked })
              console.log('[Ajustes] Switch Blog:', e.target.checked)
            }}
            className="w-6 h-6 accent-primary"
          />
        </div>
        <div className="flex items-center justify-between">
          <span className="font-medium text-white">Mostrar sección Equipo en el menú</span>
          <input
            type="checkbox"
            checked={!!config.showEquipo}
            disabled={loading}
            onChange={e => {
              updateConfig({ showEquipo: e.target.checked })
              console.log('[Ajustes] Switch Equipo:', e.target.checked)
            }}
            className="w-6 h-6 accent-primary"
          />
        </div>
        <div className="mt-4 text-xs text-gray-400">
          <span>Estado actual: </span>
          <span>Blog: <b>{config.showBlog ? 'Visible' : 'Oculto'}</b>, Equipo: <b>{config.showEquipo ? 'Visible' : 'Oculto'}</b></span>
        </div>
      </div>
    </div>
  )
}
